/**
 * STARDUST — cartridge palette.
 *
 * Deep-space vertical shooter aesthetic, distinct from the road cartridges.
 * Black void background with a starfield, hot meteor colors (orange/red),
 * cold saucer (cyan/magenta) for clean target discrimination, and bright
 * white shards that read as "loose ammo I should grab" against the dark.
 */

// Field.
export const SPACE_BG = '#020308';
export const SPACE_BG_2 = '#070912';
export const STAR_DIM = '#3a3a52';
export const STAR_MID = '#8a8aa0';
export const STAR_BRIGHT = '#e8e8f0';

// Player ship — friendly blue/cyan in the cold spectrum so the warm meteors
// pop as the threat layer.
export const SHIP_BODY = '#3aa0ff';
export const SHIP_BODY_HI = '#bff7ff';
export const SHIP_THRUSTER = '#ffb030';
export const SHIP_THRUSTER_HOT = '#ffea00';
export const SHIP_BULLET = '#ffea00';

// Meteor: warm hot-rock palette. Three tiers shaded differently so size
// reads at a glance even when small.
export const METEOR_LARGE = '#c85a30';
export const METEOR_LARGE_DARK = '#7a3018';
export const METEOR_MED = '#e08040';
export const METEOR_MED_DARK = '#8a4520';
export const METEOR_SMALL = '#ffa050';
export const METEOR_SMALL_DARK = '#a05828';

// White shards — loose ammo collectible. Pure bright white so it visually
// reads as "different from meteors, grab me." A subtle yellow tint signals
// "ammo, like the bullet color."
export const SHARD_BODY = '#fff8d0';
export const SHARD_GLINT = '#ffffff';

// Saucer: cold cyan body, magenta cockpit. Looks alien against the warm
// meteors, immediately reads as a different threat type.
export const SAUCER_BODY = '#30d0d0';
export const SAUCER_BODY_DARK = '#108080';
export const SAUCER_COCKPIT = '#ff40c0';
export const SAUCER_BOMB = '#ff4040';

// HUD.
export const HUD_TEXT = '#7af3c8';
export const HUD_SCORE = '#ffea00';
export const HUD_AMMO = '#fff8d0';
export const HUD_AMMO_LOW = '#ff4040';
export const HUD_WAVE = '#3aa0ff';

// Effects.
export const FLASH_HIT = '#fff8d0';
export const CRASH_FLASH = '#ff3040';

/** Tokens the cabinet samples for marquee tinting while this cartridge is loaded. */
export const PALETTE_HINT: readonly string[] = [
  METEOR_LARGE,
  SAUCER_BODY,
  SHIP_BODY,
  SHARD_BODY,
];
